export default {
  es: {
    enlaces: {
      sala_de_prensa: "/sala-de-prensa",
      quienes_somos: "/quienes-somos",
      productos: "/productos",
      producto: "/producto",
      clientes: "/clientes",
      contacto: "/contacto",
      trabaja_con_nosotros: "/trabaja-con-nosotros",
      politica_privacidad: "/politica-de-privacidad",
      politica_cookies: "/politica-de-cookies",
      plataforma_e_learning: "plataforma-e-learning",
      orientacion_profesional: "orientacion-profesional",
      gestor_de_formacion: "gestor-de-formacion",
      crm_fundaciones: "crm-fundaciones",
      simuladores: "simuladores"
    },
    menu: {
      inicio: "Inicio",
      situacionactual: "Situación actual",
      quees: "¿Qué es?",
      queofrece: "Qué ofrece",
      ventajas: "Ventajas",
      caracteristicas: "Características",
      comofunciona : "Cómo funciona",
      contacto : "Contacto"
    },
    home: {
    },
    contacto: {
      title: "Contacto",
      boxAdress: {
        title: " También puedes contactar con nosotros aquí:",
        direccion: "Calle Aguacate 41 Ed 4B - 2º Oficina 6 28045 MADRID",
        tel: "91 142 78 87",
        telTo: "91 142 78 87",
        mailto: "mailto:contacto@iformalia.es ",
        mail: "contacto@iformalia.es "
      }
    },
    formulario: {
      title: "Contacta con nosotros y solicita tu demo",
      description:
        "Para cualquer duda o solicitud de información rellena este cuestionario y te contestaremos lo antes posible.",
      nombre_apellidoslabel: "Nombre y apellidos",
      emailLabel: "Correo Electrónico",
      tfno: "Teléfono",
      empresaLabel: "Empresa",
      nombre: "Nombre",
      producto: "Prodotti",
      optionProduct: {
        seleccionar: "Selecciona el producto a consultar",
        orientacion: "Orientación profesional",
        plataforma: "Plataforma E-learning Cp’s",
        "gestor-formacion": "Gestor de Formación",
        CRM: "CRM Fundaciones",
        digilitalizacion: "Digitalización de contenidos"
      },
      mensajeLabel: "Mensaje",
      nombre_apellidos: "Escriba su nombre y apellidos",
      empresa: "Escriba el nombre de su empresa",
      apellidos: "Apellidos",
      email: "Escriba su correo electrónico",
      mensaje: "Explicanos tus necesidades",
      fecha_nacimiento: "Fecha de nacimiento",
      dia: "Día",
      mes: "Mes",
      anyo: "Año",
      area_interes: "Área de su interés",
      trabaja_actualmente: "¿Trabaja actualmente?",
      si: "Si",
      no: "No",
      carta_presentacion: "Carta de presentacion",
      meses: {
        Enero: "Enero",
        Febrero: "Febrero",
        Marzo: "Marzo",
        Abril: "Abril",
        Mayo: "Mayo",
        Junio: "Junio",
        Julio: "Julio",
        Agosto: "Agosto",
        Septiembre: "Septiembre",
        Octubre: "Octubre",
        Noviembre: "Noviembre",
        Diciembre: "Diciembre"
      },
      archivo_adjunto: "Adjuntar archivo",
      adjuntar_cv: "Adjuntar CV",
      introduce_mail: "Introduce tu email",
      pais: "País",
      telefono: "Escriba su teléfono",
      he_leido: "He leído y acepto la",
      y_acepto: "política de privacidad",
      enviar: "Enviar",
      enviado: "Enviado"
    },
    moreInfo: "Más información",

    banner_contacto: {
      title: "¿Quieres saber lo que Iformalia puede hacer por tu organización?",
      contacta: "Contacta con nosotros",
      siguenos: "Síguenos en redes sociales:",
      derechos: "Iformalia 2020 - Todos los derechos reservados",
      politicaPrivacidad: "Política de privacidad",
      politicaCookies: "Política de cookies"
    },
    banner_newsletter: {
      recibenoticias: "Recibe noticias acerca de iformalia:",
      introduceEmail: "Introduce tu email",
      enviar: "Enviar",
      HeLeidoYacepto: "He leído y acepto la ",
      politica: "política de privacidad"
    }
  },
  en: {
  },
  // -------------------

  it: {
  }
};






// WEBPACK FOOTER //
// ./src/translations/index.js